import BRANDS from "./brands";

// logos
import genericLogo from "../assets/branding/logos/alsea-white.svg";
import starbucksLogo from "../assets/branding/logos/starbucks.svg";
import vipsLogo from "../assets/branding/logos/vips.svg";
import burgerkingLogo from "../assets/branding/logos/burger-king.svg";
import dominosSingleLogo from "../assets/branding/logos/dominos-single.svg";
import dominosHorizontalLogo from "../assets/branding/logos/dominos-horizontal.svg";
import italiannisLogo from "../assets/branding/logos/italiannis.svg";
import chilisLogo from "../assets/branding/logos/chilis.svg";
import pfchangsLogo from "../assets/branding/logos/pf-changs.svg";
import cheesecakeLogo from "../assets/branding/logos/cheesecake-factory.svg";
import chipotleLogo from "../assets/branding/logos/chipotle.svg";
import sazoneWhiteLogo from "../assets/branding/logos/sazone-white.svg";
import sazoneColorLogo from "../assets/branding/logos/sazone-color.svg";

// logos por marca
const BRAND_LOGOS = {
  DEFAULT: {
    src: genericLogo,
    alt: "Alsea",
  },
  [BRANDS.STARBUCKS.id]: {
    src: starbucksLogo,
    alt: "Starbucks",
  },
  [BRANDS.VIPS.id]: {
    src: vipsLogo,
    alt: "Vips",
  },
  [BRANDS.BURGERKING.id]: {
    src: burgerkingLogo,
    alt: "Burger King",
  },
  [BRANDS.DOMINOS.id]: {
    src: dominosHorizontalLogo,
    alt: "Dominos",
  },
  [BRANDS.ITALIANNIS.id]: {
    src: italiannisLogo,
    alt: "Italiannis",
  },
  [BRANDS.CHILIS.id]: {
    src: chilisLogo,
    alt: "Chilis",
  },
  [BRANDS.PFCHANGS.id]: {
    src: pfchangsLogo,
    alt: "P.F. Changs",
  },
  [BRANDS.CHEESECAKE.id]: {
    src: cheesecakeLogo,
    alt: "The Cheesecake Factory",
  },
  [BRANDS.CHIPOTLE.id]: {
    src: chipotleLogo,
    alt: "Chipotle",
  },
  [BRANDS.SAZONE.id]: {
    src: sazoneWhiteLogo,
    alt: "Sazone",
  },
  [BRANDS.PORTON.id]: {
    src: genericLogo, // no logo
    alt: "El Porton",
  },
};

export const getBrandLogo = (brandId) => {
  if (!brandId) return BRAND_LOGOS.DEFAULT;
  return BRAND_LOGOS[brandId] || BRAND_LOGOS.DEFAULT;
};
